/* eslint-disable @typescript-eslint/naming-convention */
import { Type } from '@sinclair/typebox';
import { createPathGuidParameter } from '../../../routes/createPathParameter';
import { createdResponse, notFoundResponse, removedResponse } from '../../../routes/defaultResponses';
import { zxyObjectTableSchema } from '../object/zxyObjectTableSchema';

const objectRelationsGetItemSchema = Type.Pick(zxyObjectTableSchema, ['id', 'name', 'location']);
const objectRelationsGetItemsSchema = Type.Object({ items: Type.Array(objectRelationsGetItemSchema) });

export const objectRelationPaths = {
    '/api/objects/{objectId}/relations/parent': {
        parameters: [createPathGuidParameter('objectId')],
        get: {
            operationId: 'objectRelationControllers.getAllParents',
            responses: {
                '200': {
                    description: 'Array of objects',
                    content: {
                        'application/json': {
                            schema: objectRelationsGetItemsSchema,
                        },
                    },
                },
                ...notFoundResponse,
            },
        },
        post: {
            operationId: 'objectRelationControllers.createParentRelation',
            requestBody: {
                content: {
                    'application/json': {
                        schema: Type.Object({ parentId: Type.String({ format: 'uuid' }) }),
                    },
                },
            },
            responses: {
                ...createdResponse,
                ...notFoundResponse,
            },
        },
        delete: {
            operationId: 'objectRelationControllers.deleteParentRelation',
            requestBody: {
                content: {
                    'application/json': {
                        schema: Type.Object({ parentId: Type.String({ format: 'uuid' }) }),
                    },
                },
            },
            responses: {
                ...removedResponse,
                ...notFoundResponse,
            },
        },
    },
    '/api/objects/{objectId}/relations/child': {
        parameters: [createPathGuidParameter('objectId')],
        get: {
            operationId: 'objectRelationControllers.getAllChildren',
            responses: {
                '200': {
                    description: 'Array of objects',
                    content: {
                        'application/json': {
                            schema: objectRelationsGetItemsSchema,
                        },
                    },
                },
                ...notFoundResponse,
            },
        },
        post: {
            operationId: 'objectRelationControllers.createChildRelation',
            requestBody: {
                content: {
                    'application/json': {
                        schema: Type.Object({ childId: Type.String({ format: 'uuid' }) }),
                    },
                },
            },
            responses: {
                ...createdResponse,
                ...notFoundResponse,
            },
        },
        delete: {
            operationId: 'objectRelationControllers.deleteChildRelation',
            requestBody: {
                content: {
                    'application/json': {
                        schema: Type.Object({ childId: Type.String({ format: 'uuid' }) }),
                    },
                },
            },
            responses: {
                ...removedResponse,
                ...notFoundResponse,
            },
        },
    },
} as const;
